
export const getBaseUrl = () => {
  if (window.location.origin === process.env.REACT_APP_PRIVACY_PORTAL)
    return 'privacyportal';
  else return 'privacy';
}

export const baseURL = process.env.REACT_APP_CCPA_INTERNAL_API_HOST + `/internal/${getBaseUrl()}`;
